export default {
	操作成功: '操作成功',
	操作失败: '操作失敗',
	产品: '產品',
	当余额不足时使用信用卡自动续费: '當餘額不足時使用信用卡自動續費',
	订单: '訂單',
	订单自动续费: '訂單自動續費',
	概览: '概覽',
	个: '個',
	更换: '更換',
	获取全部: '取得全部',
	解除自动扣款: '解除自動扣款',
	确认解除自动扣款吗: '確認解除該信用卡的自動扣款嗎？',
	使用信用卡: '使用信用卡',
	使用账户余额: '使用帳戶餘額',
	首选信用卡: '首選信用卡',
	搜索订单号或IP: '搜尋訂單號或IP',
	未设置: '未設定',
	下次续费: '下次續費',
	下次续费日期: '下次續費日期',
	下次支付日期: '下次支付日期',
	续费订单: '續費訂單',
	续费记录: '續費記錄',
	账单周期: '帳單週期',
	扣款方式: '扣款方式',
	失败原因: '失敗原因',
	续费日历: '續費日曆',
	选择信用卡: '選擇信用卡',
	优先使用可用余额进行自动续费: '優先使用可用餘額進行自動續費',
	暂无订单: '暫無訂單',
	账户余额: '帳戶餘額',
	自动续费: '自動續費',
	自动续费费用: '自動續費費用',
	自动续费服务: '自動續費服務',
	自动续费设置: '自動續費設定',
	自动续费说明:
		'訂單到期前3天將會自動產生帳單，已開通自動續費的訂單將嘗試自動扣款，根據您的設定，使用帳戶餘額、設定好的信用卡，按順序或使用其中一種方式扣款！',
}
